// extracted by mini-css-extract-plugin
module.exports = {"facetDisplayRoot":"Color_facetDisplayRoot__Fx5Ed"};